/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import AnalyticsService from '../../service/analytics';
import WyPanelUtils from '../../components/panel-views/utils/wy-panel-util.js';
import WyFilter from '../../library/wy-filter.js';
import _ from 'lodash';
const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // eslint-disable-next-line no-unused-vars
  async prepareExpAndAutoPageViewByData({getters, commit},{viewBy, rawData, templateData, companyConfig}) {
    if(rawData) {
      let viewByData = JSON.parse(JSON.stringify(rawData))
      // let viewByDailyData = JSON.parse(JSON.stringify(rawData));
      let panelName = Object.keys(viewByData)[0];

      if(viewBy && panelName) {
        let legendOriginColors = [];
        if(companyConfig && companyConfig.legends && companyConfig.legends.legendColors && companyConfig.legends.legendColors.length > 0) {
          legendOriginColors = _.uniq(_.concat(companyConfig.legends.legendColors, getters.legendDefaultColors));
          // legendOriginColors = companyConfig.legends.legendColors;
        }
        else {
          legendOriginColors = getters.legendDefaultColors
        }
        // console.log(getters.companyConfig, getters.legendOriginColors)
        commit('updateLegendOriginColors', {colors: legendOriginColors});
        commit('updateLegendColors', {colors: legendOriginColors});
        switch (panelName) {
          case 'demoBot1Last3mos': {
            viewByData.demoBot1Last3mos = WyPanelUtils.arverageGroupByMinusOneCase(viewBy, viewByData.demoBot1Last3mos, ['bes', 'bas'])
            return viewByData.demoBot1Last3mos
          }
          case 'converVolLast3mos': {
            viewByData.converVolLast3mos = WyPanelUtils.totalVolumGroupByMinusOneCase(viewBy, viewByData.converVolLast3mos, ['conversations', 'contained', 'handedOff'])
            return viewByData.converVolLast3mos
          }
          

          default:
            // return templateData;
            // return formatPanelChartData(viewByData, panelName, templateData, viewBy);
        }
      }
      else {
        return {}
      }
    }
    else { 
      return templateData;
    }
  },
  
  async fetchBesBasContactReasonsSummary({getters, commit}, {targetRange}) {
    let results = [];
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await AnalyticsService.fetchBesBasContactReasonsSummary(getters.authUser, payload);
    if(res && res.status === 200 && res.data) {
      let sumTotalVolume = res.data.totalVolume; // this line is for V4 OC_V1.4.0
      let items = res.data.items;
      if(!items) {
        // for v3 backward compability
        sumTotalVolume = res.data.reduce((total, item) => { return total+item.totalVolume; }, 0);
        items = res.data;
      }

      Object.keys(items).forEach((key) => {
        let item = items[key];
        
        for(const key in item){
          if(item[key] == -1){
            item[key] = 'N/A'
          }
        }

        // item.volumePercent = item.volumePercent * 100;
        item.volumePercent = (item.totalVolume/sumTotalVolume * 100).toFixed(2); 
        // item.besPercent = -1
        item.besPercentOrigin = item.besPercent
        item.basPercentOrigin = item.basPercent
        if(item.besPercent == -1 || item.besPercent == 'N/A'){
          item.besPercent = 'N/A';
        } 
        else {
          item.besPercent = Math.round(item.besPercent * 100);
        }
        if(item.basPercent == -1 || item.basPercent == 'N/A'){
          item.basPercent = 'N/A';
        } 
        else {
          item.basPercent = Math.round(item.basPercent * 100);
        }
        if(targetRange){
          if(targetRange[item.topicDisplayName]) {
            item.besTarget = targetRange[item.topicDisplayName].bes;
            item.basTarget = targetRange[item.topicDisplayName].bas;
          }
          else if(targetRange['default']) {
            item.besTarget = targetRange['default'].bes;
            item.basTarget = targetRange['default'].bas;

            // new UI config
            if ((targetRange['default'].bes && targetRange['default'].bes.maxValue) || (targetRange['default'].bas && targetRange['default'].bas.maxValue)) {
              item.besTarget = { maxValue: targetRange['default'].bes && targetRange['default'].bes.maxValue }
              item.basTarget = { maxValue: targetRange['default'].bas && targetRange['default'].bas.maxValue }
            }
          }
        }
        results.push(item);
      })
      
      commit('updateTableModelResult', {
        results: results, 
        totalRecs: results.length, 
        totalPages: 1
      })

      return new Promise((resolve) => {
        resolve(true)
      })
    }
    else {
      return new Promise((resolve) => {
        resolve(false)
      })
    }
    
  }

}


export default {
  state,
  getters,
  mutations,
  actions
}